import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { prettifyMoney, prettifyNumber } from '@nexio/emvio-util-app';

import Widget from '../Widget/Widget';

import './SalesWidget.scss';

export default class SalesWidget extends Component {
    static propTypes = {
        currencyCode: PropTypes.string,
        lastThirtySaleAmount: PropTypes.number,
        lastThirtyVsPreviousThirtySaleAmount: PropTypes.number,
        lastThirtyRefundAmount: PropTypes.number,
        lastThirtyVsPreviousThirtyRefundAmount: PropTypes.number
    };

    renderSide(data) {
        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                <div className="widget-value">{data.value}</div>
                <div className="widget-delta">
                    <span className="material-icons">
                        {data.deltaDirection === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'}
                    </span>
                    {data.deltaText}
                </div>
            </Fragment>
        );
    }

    render() {
        const {
            currencyCode,
            lastThirtySaleAmount,
            lastThirtyVsPreviousThirtySaleAmount,
            lastThirtyRefundAmount,
            lastThirtyVsPreviousThirtyRefundAmount
        } = this.props;

        const salesVolume = {
            title: 'Last 30 Days Sales Volume',
            value: prettifyMoney(lastThirtySaleAmount, currencyCode, false),
            deltaText: `${prettifyNumber(Math.abs(lastThirtyVsPreviousThirtySaleAmount), 0, 1)}% from previous 30 days`,
            deltaDirection: lastThirtyVsPreviousThirtySaleAmount > 0 ? 'up' : 'down'
        };

        const returnVolume = {
            title: 'Last 30 Days Return Volume',
            value: prettifyMoney(lastThirtyRefundAmount * -1, currencyCode, false),
            deltaText: `${prettifyNumber(Math.abs(lastThirtyVsPreviousThirtyRefundAmount), 0, 1)}% from previous 30 days`,
            deltaDirection: lastThirtyVsPreviousThirtyRefundAmount > 0 ? 'up' : 'down'
        };

        return (
            <div className="sales-widget widget-layout">
                <div className="widget-title">
                    Sales
                </div>
                <Widget
                    left={this.renderSide(salesVolume)}
                    right={this.renderSide(returnVolume)}
                    variant="light"
                />
            </div>
        );
    }
}
